/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React, { useMemo } from 'react';
import { IconType } from 'react-icons/lib';

import { Box } from 'components/styled';

import { normalizeUrl } from 'utils';

const SocialLink: React.FC<{
	icon: IconType;
	label: string;
	href: string;
}> = ({ icon: Icon, label, href }) => {
	const url = useMemo(() => normalizeUrl(href), [href]);

	return (
		<Box
			mx={[1, 2, 3]}
			flexShrink={0}
			css={css`
				:first-of-type {
					margin-left: 0;
				}
				:last-of-type {
					margin-right: 0;
				}
			`}
		>
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={label}
			>
				<Icon color="white" size={30} />
			</a>
		</Box>
	);
};

export default SocialLink;
